import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  AdjacentHubCreateEditFormType,
  AdjacentHubCreateEditStateType,
  AdjacentHubLocationOptionType,
} from 'features/Location/@types/adjacentHub'
import { AdjacentHubItemType } from 'features/Location/services/adjacentHub'
import { getValidAdjacentLocations } from 'features/Location/utils/adjacentHub'

export const SLICE_NAME = 'adjacentHubCreateEdit'

export const initialState: AdjacentHubCreateEditStateType = {
  isOpen: false,
  mode: 'CREATE',
  isLoadingDetail: false,
  initialStatus: false,
  isSubmitting: false,
  isLoadingHubOptions: false,
  isLoadingNearbyHubOptions: false,
  hubOptions: [],
  nearbyHubOptions: [],
  form: {
    hub: null,
    maxDistance: '',
    maxAdditionalSla: '',
    maxDriverRatio: '',
    maxPickerRatio: '',
    quotaAllowed: '',
    adjacentLocationIds: [],
    status: false,
  },
}

const adjacentHubCreateEdit = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
    openCreate: () => ({ ...initialState, isOpen: true }),
    // Prefilled from the list row so the form isn't empty; fetchAdjacentHubDetail then refreshes it.
    openEdit: (_, { payload }: PayloadAction<AdjacentHubItemType>) => ({
      ...initialState,
      isOpen: true,
      mode: 'EDIT',
      initialStatus: payload.status,
      form: {
        hub: { location_id: payload.location_id, name: payload.location_name },
        maxDistance: String(payload.max_distance),
        maxAdditionalSla: String(payload.max_additional_sla),
        maxDriverRatio: String(payload.max_driver_ratio),
        maxPickerRatio: String(payload.max_picker_ratio),
        quotaAllowed: String(payload.quota_allowed),
        adjacentLocationIds: getValidAdjacentLocations(payload.adjacent_location).map(
          ({ location_id }) => location_id,
        ),
        status: payload.status,
      },
    }),
    setIsLoadingDetail: (state, action: PayloadAction<boolean>) => {
      state.isLoadingDetail = action.payload
    },
    setIsSubmitting: (state, action: PayloadAction<boolean>) => {
      state.isSubmitting = action.payload
    },
    setIsLoadingHubOptions: (state, action: PayloadAction<boolean>) => {
      state.isLoadingHubOptions = action.payload
    },
    setIsLoadingNearbyHubOptions: (state, action: PayloadAction<boolean>) => {
      state.isLoadingNearbyHubOptions = action.payload
    },
    setHubOptions: (state, action: PayloadAction<AdjacentHubLocationOptionType[]>) => {
      state.hubOptions = action.payload
    },
    setNearbyHubOptions: (state, action: PayloadAction<AdjacentHubLocationOptionType[]>) => {
      state.nearbyHubOptions = action.payload
    },
    setForm: (state, action: PayloadAction<Partial<AdjacentHubCreateEditFormType>>) => {
      state.form = { ...state.form, ...action.payload }
    },
  },
})

export const {
  reset,
  openCreate,
  openEdit,
  setIsLoadingDetail,
  setIsSubmitting,
  setIsLoadingHubOptions,
  setIsLoadingNearbyHubOptions,
  setHubOptions,
  setNearbyHubOptions,
  setForm,
} = adjacentHubCreateEdit.actions
export default adjacentHubCreateEdit.reducer
